import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface BrandDefenseData {
  impressionShare: number;
  estimatedSavings: { low: number; high: number };
  otaOpportunityPercent: number;
  [key: string]: unknown;
}

export function useBrandDefense(
  userId: string,
  dateRange?: { startDate: string; endDate: string },
) {
  return useQuery<BrandDefenseData>({
    queryKey: ["brand-defense", userId, dateRange],
    queryFn: () => api.marketing.brandDefense.get(userId, dateRange!) as Promise<BrandDefenseData>,
    enabled: !!userId && !!dateRange,
    staleTime: 5 * 60 * 1000,
  });
}
